/**
 * Точка входа SPA.
 *
 * 401 от любого запроса возвращает на страницу входа: сессия могла быть отозвана
 * админом или истечь за ночь, и показывать после этого пустые экраны нельзя.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';

import { AppProviders } from './app/providers.js';
import { router } from './app/router.js';
import { setUnauthorizedHandler } from './shared/api/client.js';
import './styles.css';

setUnauthorizedHandler(() => {
  if (window.location.pathname !== '/login') window.location.assign('/login');
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Не найден корневой элемент страницы');
}

// Витрина блоков пульта на тестовых данных — только в dev-сборке и мимо
// оболочки с сессией: пульт без сервера иначе не посмотреть (04.09.2026)
const DevPreview =
  import.meta.env.DEV && window.location.pathname === '/dev/desk-preview'
    ? (await import('./pages/dev-desk-preview.page.js')).DevDeskPreviewPage
    : null;

createRoot(container).render(
  <StrictMode>
    <AppProviders>{DevPreview === null ? <RouterProvider router={router} /> : <DevPreview />}</AppProviders>
  </StrictMode>,
);
